import React from 'react'

const UserLevelHistory = React.lazy(() => import('pages/UserLevelHistory/ULHistory'));
const UserLevelHistoryAdd = React.lazy(() => import('pages/UserLevelHistory/ULHistoryAdd'));
const UserLevelHistoryEdit = React.lazy(() => import('pages/UserLevelHistory/ULHistoryEdit'));
const UserLevelHistoryDetail = React.lazy(() => import('pages/UserLevelHistory/ULHistoryDetail'));

const UserLevelHistoryRoutes = [
    {
        path: '/user-level-history',
        exact: true,
        name: 'Lịch sử chuyển cấp',
        function: 'SYS_USERLEVEL_HISTORY_VIEW',
        component: UserLevelHistory,
    },
    {
        path: '/user-level-history/add',
        exact: true,
        name: 'Chuyển cấp',
        function: 'SYS_USERLEVEL_HISTORY_ADD',
        component: UserLevelHistoryAdd,
    },
    {
        path: '/user-level-history/edit/:id',
        exact: true,
        name: 'Chỉnh sửa',
        function: 'SYS_USERLEVEL_HISTORY_EDIT',
        component: UserLevelHistoryEdit,
    },
    {
        path: '/user-level-history/detail/:id',
        exact: true,
        name: 'Chi tiết',
        function: 'SYS_USERLEVEL_HISTORY_VIEW',
        component: UserLevelHistoryDetail,
    },
]

export default UserLevelHistoryRoutes
